// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"630":"code_activation-CodeActivationModal","777":"code_activation-PhoneVerification"}[chunkId] + "." + {"630":"cdf4a8c8d2a145391bc7","777":"d567a4c69e77899fbd69"}[chunkId] + ".js";
};